import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const { login, user, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [showEmail, setShowEmail] = useState(false);

  useEffect(() => {
    if (ready && user && user.id) nav("/quiz", { replace: true });
  }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Accesso effettuato");
      nav("/quiz");
    } else {
      setErr(r.error || "Errore");
    }
  };

  return (
    <section className="section-pad">
      <div className="max-w-md mx-auto px-6">
        <p className="eyebrow mb-4">Area riservata</p>
        <h1 className="font-display text-4xl text-[#2A3229] mb-2">Accedi al Check‑Up</h1>
        <p className="text-[#5A6058] mb-10">Un clic per entrare nell'area riservata. Il tuo profilo verrà creato automaticamente al primo accesso.</p>

        <GoogleButton label="Continua con Google" testid="login-google" />

        <div className="mt-8 flex items-center gap-4">
          <div className="flex-1 h-px bg-[#323C36]/15"/>
          <span className="text-xs uppercase tracking-widest text-[#5A6058]">oppure</span>
          <div className="flex-1 h-px bg-[#323C36]/15"/>
        </div>

        {!showEmail ? (
          <button
            data-testid="show-email-login"
            onClick={() => setShowEmail(true)}
            className="mt-8 w-full text-sm text-[#5A6058] hover:text-[#323C36] underline underline-offset-4"
          >
            Ho già un account con email e password
          </button>
        ) : (
          <form onSubmit={submit} data-testid="login-form" className="mt-8 space-y-6">
            <input data-testid="login-email" required type="email" placeholder="Email" className="field-input" value={email} onChange={e=>setEmail(e.target.value)} />
            <input data-testid="login-password" required type="password" placeholder="Password" className="field-input" value={password} onChange={e=>setPassword(e.target.value)} />
            {err && <p data-testid="login-error" className="text-sm text-[#A8674F]">{err}</p>}
            <button data-testid="login-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">{loading ? "Accesso…" : "Accedi con email"}</button>
            <p className="text-sm text-[#5A6058] text-center">Non hai un account? <Link to="/registrati" className="text-[#323C36] underline" data-testid="to-register">Registrati</Link></p>
          </form>
        )}
      </div>
    </section>
  );
}
